<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const variants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'bg-primary px-6 py-4 tracking-wide text-white hover:bg-white hover:text-primary focus-visible:bg-white focus-visible:text-primary',
        ghost: 'text-primary hover:text-primary/90 focus-visible:text-primary/90',
        icon: 'aspect-square size-10 rounded-full bg-white text-primary hover:bg-primary hover:text-white focus-visible:bg-primary focus-visible:text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

interface Props {
  variant?: NonNullable<Parameters<typeof variants>[0]>['variant'];
  as?: 'button' | 'a';
}

withDefaults(defineProps<Props>(), {
  as: 'button',
});
</script>

<template>
  <component :is="as" :class="cn(variants({ variant }), $attrs.class ?? '')">
    <slot />
  </component>
</template>
